module.exports = __webpack_public_path__ + "static/media/title_coven_bleed.729e00ed.svg";